import { fetcher } from 'utils/RockFetch';

const RequestWrapper = (asJson: boolean, forceFetch: boolean, signal: AbortSignal) => {
  return [
    '',
    {
      fetch: function useFetchWrapper(url, p: RequestInit) {
        return fetcher(url, p.method, p.body, asJson, forceFetch, signal);
      },
    },
  ];
};

const ModelFactory = (Type, asJson = false, forceFetch = false, signal = null) => {
  return new Type(...RequestWrapper(asJson, forceFetch, signal));
};

export default ModelFactory;
